// Module
var code = "<template> <require from=\"app/pp/components/todo/todo-grid\"></require> <todo-grid></todo-grid> </template> ";
// Exports
module.exports = code;